import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
    selector: 'app-warning',
    templateUrl: './warning.component.html',
    styleUrls: ['./warning.component.scss']
})
export class WarningComponent implements OnInit {
    @ViewChild('dialog') dialogRef: DialogComponent;

    color = 'accent';
    icon = 'warning';
    message = '';
    title = 'Error';
    btn = '';

    constructor() { }

    ngOnInit() {
    }

    show () {
        return this.dialogRef.show()
    }

}
